import React from 'react';

import { Footer } from '../../micros/Footer';

import { FooterProps } from '../../micros/Footer/types';

const SectionFooter = (props: FooterProps) => {
	return <Footer {...props} />;
};

export default SectionFooter;
